import Vue from "vue"
import {isAuthenticated} from "../services/authentication_service"

Vue.mixin({
    computed: {
        isAuthenticated: function(){
            return isAuthenticated()
        }
    }
})